
import { setToken, removeToken } from '../../utils/auth'
export const types = {
    SET_TOKEN: 'setToken',
    REMOVE_TOKEN: 'removeToken'
}

const initalState = {
    token: sessionStorage.getItem('token')
}

export default function reducer(state = initalState, action: any = {}) {
    switch (action.type) {
        case types.SET_TOKEN:
            sessionStorage.setItem('token', action.token)
            setToken(action.token)
            return {
                ...state,
                token: action.token
            }
        case types.REMOVE_TOKEN:
            sessionStorage.removeItem('token')
            removeToken()
            return {
                ...state,
                token: action.token
            }
        default: return state
    }
}

export const userActions = {
    setToken: function(data: object) {
        return { type: types.SET_TOKEN, ...data }
    },
    removeToken: function(data: object) {
        return { type: types.REMOVE_TOKEN, ...data }
    }

}